<template>
    <div>
        <div id="printContent" class="print-zone">
            <div v-for="(item, index) in printList" :key="index">
                <div class="print-title-view">
                    <div class="order-code">
                        <!-- <svg id="barcode" /> -->
                        <canvas id="canvas" class="qrcode-canvas" ref="canva"></canvas>
                        <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" />
                    </div>
                    <div class="print-title">采购入库单</div>
                    <div class="company">
                        <div>采购单号：{{ orderCode }}</div>
                        <div>采购单位：{{ company }}</div>
                    </div>
                </div>

                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">供应商名称</div>
                        <div class="div-table-cell" style="width: 80%">
                            {{ item.EntpCusName }}
                        </div>
                    </div>
                    <!-- <div class="div-table-row">
            <div class="div-table-cell" style="width: 20%">联系电话</div>
            <div class="div-table-cell" style="width: 80%"></div>
          </div> -->
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%">序号</div>
                        <div class="div-table-cell" style="width: 16%">汽配编码</div>
                        <div class="div-table-cell" style="width: 21%">配件名称</div>
                        <div class="div-table-cell" style="width: 20%">车型</div>
                        <div class="div-table-cell" style="width: 10%">已入数量</div>
                        <div class="div-table-cell" style="width: 10%">单位</div>
                        <div class="div-table-cell" style="width: 12%">采购价</div>
                        <div class="div-table-cell" style="width: 15%">采购总价</div>
                        <!-- <div class="div-table-cell" style="width: 15%">仓位</div>
            <div class="div-table-cell" style="width: 10%">备注</div> -->
                    </div>
                    <div class="div-table-row" v-for="(AP, index) in item.DetailList" :key="index">
                        <div class="div-table-cell" style="width: 6%">
                            {{ AP.SortNum == 0 ? Number(index) + 1 : AP.SortNum }}
                        </div>
                        <div class="div-table-cell" style="width: 16%">{{ AP.APCode }}</div>
                        <div class="div-table-cell" style="width: 21%">
                            {{ AP.GoodName }}
                        </div>
                        <div class="div-table-cell" style="width: 20%">适用:{{ AP.AutoSerise }}</div>
                        <div class="div-table-cell" style="width: 10%">{{ AP.Count }}</div>
                        <div class="div-table-cell" style="width: 10%">{{ AP.Unit }}</div>
                        <div class="div-table-cell" style="width: 12%">{{ AP.Price }}</div>
                        <div class="div-table-cell" style="width: 15%">
                            {{ (AP.Price * AP.Count).toFixed(2) }}
                        </div>
                        <!-- <div class="div-table-cell" style="width: 15%">{{AP.GoodsLocation}}</div>
            <div class="div-table-cell" style="width: 10%">{{AP.Remark}}</div> -->
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%"></div>
                        <div class="div-table-cell" style="width: 16%"></div>
                        <div class="div-table-cell" style="width: 21%"></div>
                        <div class="div-table-cell" style="width: 20%">总数量</div>
                        <div class="div-table-cell" style="width: 10%">{{ allNum }}</div>
                        <div class="div-table-cell" style="width: 10%"></div>
                        <div class="div-table-cell" style="width: 12%">总价</div>
                        <div class="div-table-cell" style="width: 15%">{{ allPrice }}</div>
                        <!-- <div class="div-table-cell" style="width: 15%"></div>
            <div class="div-table-cell" style="width: 10%"></div> -->
                    </div>
                    <!-- <div class="div-table-row">
            <div class="div-table-cell" style="width: 6%">备注</div>
            <div class="div-table-cell" style="width: 94%">{{item.Remark}}</div>
          </div>-->
                </div>
                <div class="order-remark">
                    <div>{{ item.Remark ? '备注：' + item.Remark : '' }}</div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button class="btn-primary" v-print="'#printContent'" @click="printedRecord">打印</el-button>
            <el-button @click="cancel()">关闭</el-button>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
// import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';
export default {
    name: '',
    components: {},
    props: ['printId', 'printType', 'recordIds'],
    data() {
        return {
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: this.$util.getLocalStorage('userMsg').EntpName,
            orderCode: '',
            imgUrl: '',
            type: 0
        };
    },
    mounted() {
        if (this.printType) this.type = +this.printType;
        this.getPurchaseOrder();
    },
    watch: {
        orderCode(value) {
            this.$nextTick(function () {
                try {
                    let canvas = this.$refs.canva[0];
                    QRCode.toCanvas(
                        canvas,
                        value,
                        {
                            width: 80,
                            height: 80,
                            margin: 0,
                            scrollX: 0,
                            scrollY: 0
                        },
                        function (error) {}
                    );

                    setTimeout(() => {
                        html2canvas(canvas, {
                            width: 80,
                            height: 80,
                            scrollX: 0,
                            scrollY: 0
                        }).then(canvasRes => {
                            var imgData = canvasRes.toDataURL('image/png');
                            this.imgUrl = imgData;
                            canvas.style.display = 'none';
                        });
                    }, 1000);
                } catch (e) {
                    //
                }
            });
        }
    },
    methods: {
        cancel() {
            this.$emit('closeDialog');
        },
        printedRecord() {
            this.$util.printedRecord(
                {
                    OrderId: this.printId,
                    Type: 8
                },
                true
            );
        },
        getPurchaseOrder() {
            if (this.type === 0)
                this.$util
                    .axiosGet({
                        url: '/api/EntpPurchaseOrder/GetEntpPurPartInPrint',
                        data: {
                            EntpCusPOId: this.printId
                        }
                    })
                    .then(res => {
                        let _allNum = 0;
                        let _allPrice = 0;
                        let data = res.data;
                        let DetailList = data.DetailList;
                        for (let i = 0; i < DetailList.length; i++) {
                            _allNum += Number(DetailList[i].Count);
                            _allPrice += DetailList[i].Count * DetailList[i].Price;
                        }
                        this.allNum = _allNum;
                        this.allPrice = _allPrice.toFixed(2) * 1;
                        this.printList.push(res.data);
                        this.orderCode = data.OrderCode;
                    });
            else
                this.$util
                    .axiosPost({
                        url: '/api/EntpPurchaseOrder/GetEntpPurPartInPrint',
                        data: {
                            OrderId: this.printId,
                            RecordIds: this.recordIds
                        }
                    })
                    .then(res => {
                        let _allNum = 0;
                        let _allPrice = 0;
                        let data = res.data;
                        let DetailList = data.DetailList;
                        for (let i = 0; i < DetailList.length; i++) {
                            _allNum += Number(DetailList[i].Count);
                            _allPrice += DetailList[i].Count * DetailList[i].Price;
                        }
                        this.allNum = _allNum;
                        this.allPrice = _allPrice.toFixed(2) * 1;
                        this.printList.push(res.data);
                        this.orderCode = data.OrderCode;
                    });
        }
    }
};
</script>
<style lang="less" scoped>
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px 0;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
}
.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 0px 0px 15px 0px;
    color: #000;
}
.company {
    color: #000;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
}
.dialog-footer {
    text-align: right;
}
.print-table-main {
    margin-bottom: 20px;
    font-size: 12px;
    .div-table-row {
        border-color: black;
        margin-left: 0;
    }
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
}
</style>
